import { render, staticRenderFns } from "./IbNavigationButton.vue?vue&type=template&id=569b704b&scoped=true"
import script from "./IbNavigationButton.vue?vue&type=script&lang=js"
export * from "./IbNavigationButton.vue?vue&type=script&lang=js"
import style0 from "./IbNavigationButton.vue?vue&type=style&index=0&id=569b704b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569b704b",
  null
  
)

export default component.exports